<template>
	<div>
		<ChangeController
			:visible="dataChanged"
			@close="show = false"
			@revert="revert"
			@save="save"
		/>

		<section class="mt-10 mb-10">
			<TextEditor v-model="data.text" @show-change="dataChanged = true" />
		</section>

		<v-tabs 
		background-color="secondary"
		slider-color="primary"
		grow
		icons-and-text
		elevation='10'
>
			<template v-for="item in data.items">
				<v-tab :key="`tab-${item.title}`">
					<v-icon left>{{ item.icon }}</v-icon>
					{{ item.title }}
				</v-tab>
				<v-tab-item :key="`content-${item.title}`">
					<v-card-text>
						<section class="mb-10">
							<h2 class="text-h4 mb-4" v-text="item.title" />

							<TextEditor
								v-model="item.text"
								@show-change="dataChanged = true"
							/>
						</section>
						<section class="mb-10">
							<Collection
								cols="auto"
								:collection="item.files"
								@change="dataChanged = true"
								dialogWidth="600"
								:form="$options.FileForm"
								title="Media File"
								
								isFileUpload
							>
								<MediaItem slot-scope="{ item }" v-bind="item" />
							</Collection>
						</section>
					</v-card-text>
					<v-row> </v-row>
					<v-row>
						<v-col> </v-col>
					</v-row>
				</v-tab-item>
			</template>
		</v-tabs>
	</div>
</template>

<script>
import TextEditor from '@/components/admin/TextEditor'

import Collection from '@/components/admin/ItemCollection'
import MediaItem from '@/components/n-collections/n-items/MediaItem'

import FileForm from '@/components/dialogs/forms/FileForm'

import DataMixin from '@/mixins/DataMixin'

export default {
	name: 'AdminMedia',
	mixins: [DataMixin],
	FileForm,
	components: {
		TextEditor,
		Collection,
		MediaItem,
	},
}
</script>

<style lang="scss" scoped>
</style>